import { RioCategory } from '@backoffice-frontend/graphql'
import type { RioTemplateFragment } from '../graphql'

export const rioCategoryLabelMapper: Record<
  RioCategory,
  keyof Pick<RioTemplateFragment, 'title' | 'viewReportTitle'>
> = {
  [RioCategory.Accident]: 'title',
  [RioCategory.DamageReport]: 'viewReportTitle',
  [RioCategory.Disruption]: 'viewReportTitle',
  [RioCategory.NonAdVehicleChecks]: 'viewReportTitle',
  [RioCategory.VehicleChecks]: 'viewReportTitle',
}
